import React, { useRef, useEffect, useState } from "react";
import { Box, Grid, Divider } from "@mui/material";
import { Text } from "@chakra-ui/react";
import backgroundImg from "../resources/images/generated/background-white-v1.png";

export default function Impressum() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const headingRef = useRef(null);

  useEffect(() => {
    setIsSmallScreen(window.innerWidth < 1200);
    // Scroll to top and focus the heading for screenreaders
    window.scrollTo({ top: 0, behavior: "smooth" });
    headingRef.current?.focus();
  }, []);

  return (
    <>
      {/* Skip-Link */}
      <a
        href="#impressum"
        className="skip-link"
        style={{
          position: "absolute",
          top: -40,
          left: 0,
          background: "#000",
          color: "#fff",
          padding: "8px 16px",
          zIndex: 2000,
          textDecoration: "none",
        }}
      >
        Zum Inhalt springen
      </a>

      <Grid
        container
        style={{
          marginTop: "0em",
          display: "flex",
          minHeight: "100vh",
          overflow: "auto",
        }}
      >
        <Grid
          component="main"
          id="impressum"
          role="main"
          item
          xs={12}
          md={12}
          alignItems="center"
          alignContent="center"
        >
          <Grid
            container
            style={{ marginTop: "0em" }}
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item style={{ height: "5vh" }} />

            <Grid
              item
              style={{
                backgroundColor: "white",
                padding: "3em",
                borderRadius: "3px",
                width: isSmallScreen ? "90%" : "80%",
                color: "black",
              }}
            >
              {/* Überschrift */}
              <Text
                as="h1"
                fontSize="lg"
                fontWeight="bold"
                fontFamily={"quicksand"}
                ref={headingRef}
                tabIndex={-1}
                mb={2}
              >
                Impressum
              </Text>
              <Divider
                style={{
                  backgroundColor: "lightgrey",
                  margin: "5px 0px 20px 0px",
                }}
              />

              {/* Adresse */}
              <Text as="address" fontSize="lg" mb={2}>
                BDG Wohnbau GmbH
                <br />
                Persantestr. 18
                <br />
                14167 Berlin
                <br />
                Deutschland
              </Text>

              {/* Kontaktdaten */}
              <Text fontSize="md" mb={4}>
                Vertretungsberechtigter Geschäftsführer: Kevin Golanko
                <br />
                Registergericht: Amtsgericht Charlottenburg
                <br />
                Registernummer: HRB 252274 B
                <br />
                Umsatzsteuer-ID gemäß § 27a UStG: DE361125009
                <br />
                <br />
                Kontakt:
                <br />
                Telefon:{" "}
                <a href="tel:+4917643540133">+49 176 43540133</a>
                <br />
                E-Mail:{" "}
                <a href="mailto:verwaltung@bdg-wohnbau.de">
                  verwaltung@bdg-wohnbau.de
                </a>
                <br />
                <br />
                Verantwortlich nach § 55 Abs. 2 RStV:
                <br />
                Kevin Golanko
                <br />
                Persantestr. 18
                <br />
                14167 Berlin
                <br />
                Deutschland
                <br />
                <br />
                <b>Haftungsausschluss:</b>
                <br />
                Alle Inhalte unseres Internetauftritts wurden mit größter
                Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und
                Aktualität übernehmen wir jedoch keine Gewähr. Wir sind nach
                § 7 TMG für eigene Inhalte verantwortlich. Externe Links sind
                vom Zeitpunkt der Linksetzung überprüft; ohne konkrete
                Anhaltspunkte einer Rechtsverletzung ist eine ständige
                Kontrolle unzumutbar. Bei Kenntnis entfernen wir rechtswidrige
                Inhalte unverzüglich.
                <br />
                <br />
                <b>Haftungsbeschränkung für externe Links:</b>
                <br />
                Wir haben auf Inhalte verlinkter Seiten keinen Einfluss und
                übernehmen daher keine Gewähr. Die Anbieter der verlinkten
                Seiten sind verantwortlich. Werden uns Rechtsverletzungen
                bekannt, entfernen wir die Links unverzüglich.
                <br />
                <br />
                <b>Urheberrecht:</b>
                <br />
                Die durch uns erstellten Inhalte und Werke unterliegen dem
                deutschen Urheberrecht. Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der
                Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung
                des Urhebers. Inhalte Dritter sind als solche gekennzeichnet.
                Hinweise auf Urheberrechtsverletzungen nehmen wir dankend
                entgegen und entfernen Inhalte unverzüglich.
                <br />
                <br />
                <b>Datenschutzinformation:</b>
                <br />
                Personenbezogene Daten aus dem Kontaktformular (Name,
                E-Mail, Telefon) dienen ausschließlich der Bearbeitung Ihrer
                Anfrage.
                <br />
                <b>Zweck:</b> Bearbeitung Ihrer Anfrage
                <br />
                <b>Rechtsgrundlage:</b> Art. 6 Abs. 1 lit. a DSGVO
                <br />
                <b>Speicherdauer:</b> Bis Ende des Kalenderjahres
                <br />
                <b>Weitergabe:</b> Keine an Dritte
                <br />
                <b>Ihre Rechte:</b> Auskunft, Berichtigung, Löschung,
                Einschränkung, Datenübertragbarkeit, Widerruf
                <br />
                Für Fragen:{" "}
                <a href="mailto:verwaltung@bdg-wohnbau.de">
                  verwaltung@bdg-wohnbau.de
                </a>
                <br />
                <br />
                Dieses Impressum wurde freundlicherweise von jurarat.de
                zur Verfügung gestellt.
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Dekoratives Hintergrundbild */}
      <div
        style={{
          backgroundImage: `url('${backgroundImg}')`,
          backgroundRepeat: "repeat-y",
          backgroundSize: "100%",
          opacity: 0.4,
          width: "100%",
          position: "absolute",
          zIndex: "-1",
        }}
        aria-hidden="true"
      />
    </>
  );
}
